import React from 'react'
import axios from 'axios';

import { FileDownload } from '@mui/icons-material'

import { useDataAuth } from '../../hooks/useDataAuth';
import { ActionIconItem } from './ActionIconItem';
import { resolveActionConfig } from '../../helpers/configResolver';

const readPresignedUrl = (data) => {
    if (typeof data === 'string') {
        const trimmed = data.trim();
        if (trimmed.startsWith('http://') || trimmed.startsWith('https://')) return trimmed;
        try {
            const parsed = JSON.parse(trimmed);
            if (typeof parsed?.url === 'string' && parsed.url.startsWith('http')) return parsed.url;
        } catch (error) {
            return '';
        }
        return '';
    }
    if (typeof data?.url === 'string' && data.url.startsWith('http')) return data.url;
    return '';
};

export const DownloadFile = ({ path, bucket, idFlow = null, data = null, rowData = null, companyInfo = {} }) => {
    const [{ userSession }] = useDataAuth();
    const DownloadClick = async (pathValue, bucketValue, flowId) => {
        const resolved = resolveActionConfig(
            {
                id_flow: flowId ?? '8',
                bucket: bucketValue,
                path: pathValue
            },
            rowData,
            companyInfo
        );
        const bodyData = {
            id_flow: resolved.id_flow,
            bucket: resolved.bucket,
            path: resolved.path
        };

        let name = String(bodyData.path || '').split('/').pop();
        let ext = name.split('.').pop();

        const baseUrlFlow = process.env.REACT_APP_AWS_API_GATEWAY_URL_EXECUTE_FLOW;
        let config = {
            method: 'POST',
            url: baseUrlFlow,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${userSession.token}`
            },
            data: JSON.stringify(bodyData)
        };

        try {
            const response = await axios.request(config);
            if (response.status === 200) {
                const presigned = readPresignedUrl(response.data);
                if (presigned) {
                    const opened = window.open(presigned, '_blank', 'noopener,noreferrer');
                    if (!opened) {
                        const direct = document.createElement('a');
                        direct.href = presigned;
                        direct.target = '_blank';
                        direct.rel = 'noopener noreferrer';
                        document.body.appendChild(direct);
                        direct.click();
                        document.body.removeChild(direct);
                    }
                    return;
                }
                const byteCharacters = atob(response.data);
                const byteNumbers = new Array(byteCharacters.length);
                for (let i = 0; i < byteCharacters.length; i++) {
                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                }
                const byteArray = new Uint8Array(byteNumbers);
                const blob = new Blob([byteArray], { type: `application/${ext}` });
                const url = URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', name);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
            else
                console.error('R_ ', response.status);
        } catch (error) {
            console.error(error);
        }
    };

    return (
        <>
            {
                data ?
                    <ActionIconItem
                        item={data}
                        onClick={() => DownloadClick(path, bucket, idFlow)}
                        defaultIcon="Task"
                    />
                    :
                    path &&
                    <FileDownload
                        style={{ fontSize: 25, color: 'black', cursor: 'pointer' }}
                        onClick={() => DownloadClick(path, bucket, idFlow)}
                    />
            }
        </>
    )
}